"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEqual = void 0;
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
exports.isEqual = fast_deep_equal_1.default;
//# sourceMappingURL=is-equal.js.map